<template>
  <div>
    <list-scroll v-if="files.length" ref="scroll" height="250px" class="mb-3 mt-3">
      <player-row v-for="file in files" :key="file.sln_file" :file="file">
        <icon slot="controls" class="mb-1" type="md-trash" :size="20" @click="remove(file.id)" />
      </player-row>
    </list-scroll>
    <upload
      :headers="headers"
      :action="url"
      :accept="accept"
      :format="format"
      :multiple="true"
      :show-upload-list="false"
      :on-success="on_success"
      type="drag"
      class="dnd-uploader"
      v-on="$listeners"
      ref="upload"
    >
      <div class="dnd-uploader__drop-zone">
        <div v-if="loading" class="drop-zone__loader">
          <spin size="large" />
        </div>

        <icon v-if="!loading" type="ios-cloud-upload" size="52" class="drop-zone__icon" />

        <p class="text-center text-muted">{{ $t('shared.component.file_upload.drag') }}</p>
      </div>
    </upload>
    <p class="small text-muted mb-2 mt-2">
      {{ $t('shared.component.file_upload.format') }}: {{ format_user }}
    </p>
    <p class="small text-muted">
      {{ $t('shared.component.file_upload.weight') }}
    </p>
  </div>
</template>

<script>
  import { getBaseURL } from '@shared/helpers/url';
  import PlayerRow from '@pbx/components/media/_fragments/file-player-row';
  import { MediaService } from '@pbx/services/MediaService';
  const formats = ['mp3', 'wav'];

  export default {
    components: {
      PlayerRow
    },
    data: () => ({
      url: getBaseURL('/api/v2/pbx/mediafiles'),
      accept: formats.map((i) => `.${i}`).join(','),
      format_user: formats.map((i) => `.${i}`).join(', '),
      format: formats,
      loading: false,
      file: null,
      files: []
    }),
    computed: {
      headers: function () {
        return {
          Authorization: `Bearer ${this.$store.getters['core/auth/token']}`
        };
      }
    },
    watch: {
      files: {
        handler: function () {
          if (this.files.length)
            setTimeout(() => {
              this.$refs.scroll.refresh();
            }, 0);
        }
      }
    },
    methods: {
      remove(id) {
        MediaService.removeItem(id).then(() => {
          for (let i in this.files) {
            if (this.files[i].id == id) {
              this.$emit('remove', this.files[i].id);
              this.files.splice(i, 1);
            }
          }
        });
      },
      async on_success(e) {
        this.files.push(e);
        this.loading = false;
        this.$emit('success', e);
      }
    }
  };
</script>

<style lang="scss">
  .dnd-uploader {
    &__drop-zone {
      padding: 20px 0;

      .text-center {
        margin: 0 5px;
      }
    }
  }

  .drop-zone__loader {
    height: 52px;
    width: 52px;
    margin: 0 auto;
  }

  .drop-zone__icon {
    color: $primary;
  }
</style>
